import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20artistic%20collage%20background%20warm%20orange%20and%20amber%20tones%20abstract%20comic%20book%20elements%20soft%20gradients%20geometric%20patterns%20modern%20minimal%20design%20atmospheric%20with%20subtle%20line%20art%20aesthetic&width=1600&height=900&seq=hero-bg-comics-01&orientation=landscape"
          alt="韩国漫画网 - 免费韩漫大全"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
            免费韩漫大全
            <span className="block mt-2 text-2xl md:text-4xl lg:text-5xl text-primary-300">
              好看韩国漫画在线观看
            </span>
          </h1>
          <p className="mt-6 text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mx-auto">
            通过漫画网址访问韩国漫画网，即可浏览海量免费韩漫资源。
            覆盖<strong>恋爱</strong>、<strong>奇幻</strong>、<strong>动作</strong>、<strong>悬疑</strong>等多种类型，
            支持韩漫在线观看，为您带来极致的阅读体验。
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/romance"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200"
            >
              <i className="ri-book-open-line"></i>
              开始阅读
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white rounded-full font-medium text-sm border border-white/20 hover:bg-white/20 transition-all duration-200"
            >
              <i className="ri-information-line"></i>
              了解更多
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {[
              { number: '10,000+', label: '漫画资源' },
              { number: '500万+', label: '月活跃用户' },
              { number: '8大', label: '漫画分类' },
              { number: '每日', label: '准时更新' },
            ].map((stat) => (
              <div key={stat.label} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.number}</div>
                <div className="text-xs md:text-sm text-white/70 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}